import { request } from '@umijs/max';

export async function submitFeedback(data: {
  category?: string;
  content: string;
  contactEmail?: string;
  pageUrl?: string;
  browserInfo?: string;
  screenshotUrls?: string[];
  npsScore?: number;
}) {
  return request('/app-api/feedback', {
    method: 'POST',
    data,
  });
}
